<template>
	<div class="AddSupplierDetails">
		<div>
			<div class="supplier-contact">
				<div class="form border-r-4">
					<div>
						<p class="text-center text-xl">
							Supplier
						</p>
					</div>
					<div class="from-fields">
						<label for="">
							Supplier Name
						</label>
						<BaseInput
							class="baseInput"
							custom-class="p-2 text-sm  text-amp-input-boxes"
							placeholder="Supplier Name"
						/>
					</div>
					<div class="from-fields">
						<label for="">
							Supplier Id
						</label>
						<BaseInput
							class="baseInput"
							custom-class="p-2 text-sm  text-amp-input-boxes"
							placeholder="Supplier Id"
						/>
					</div>
					<div class="from-fields">
						<label for="">
							Supplier Name
						</label>
						<div>
							<el-select
								v-model="value"
								style="width: 100%;"
								collapse-tags
								placeholder="Supplier Name"
							>
								<el-option
									v-for="outlet in 5"
									:key="outlet"
									:label="outlet"
									:value="outlet"
								/>
							</el-select>
						</div>
					</div>
					<div class="from-fields">
						<label for="">
							Minimum Order($)
						</label>
						<div>
							<BaseInput
								class="baseInput"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Minimum Order($)"
							/>
						</div>
					</div>
				</div>
				<div class="form">
					<div>
						<p class="text-center text-xl">
							Contact
						</p>
					</div>
					<div>
						<div class="from-fields">
							<label for="">
								First Name
							</label>
							<BaseInput
								class="baseInput"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="First Name"
							/>
						</div>
						<div class="from-fields">
							<label for="">
								Last Name
							</label>
							<BaseInput
								class="baseInput"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Last Name"
							/>
						</div>
						<div class="from-fields">
							<label for="">
								Email
							</label>
							<BaseInput
								class="baseInput"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Email"
							/>
						</div>
						<div class="from-fields">
							<label for="">
								Alternative Email
							</label>
							<div>
								<BaseInput
									class="baseInput"
									custom-class="p-2 text-sm  text-amp-input-boxes"
									placeholder="Alternative Email"
								/>
							</div>
						</div>
						<div class="from-fields">
							<label for="">
								Office Phone
							</label>
							<div>
								<BaseInput
									class="baseInput"
									custom-class="p-2 text-sm  text-amp-input-boxes"
									placeholder="Office Phone"
								/>
							</div>
						</div>
						<div class="from-fields">
							<label for="">
								Mobile
							</label>
							<div>
								<BaseInput
									class="baseInput"
									custom-class="p-2 text-sm  text-amp-input-boxes"
									placeholder="Cell Phone"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="contact" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AddSupplierDetails",
	data() {
		return {
			value: ""
		};
	}
};
</script>

<style lang="scss" scoped>
@import "./AddSupplierDetails.scss";
</style>
